<template>
  <div class="page_warpper">
    <div class="toolbar">
      <ui-select
        disable-filter
        has-search
        label="Wine"
        placeholder="Please select"
        search-placeholder="code or name"
        :loading="select11Loading"
        :no-results="select11NoResults"
        :options="select11Options"
        @query-change="onQueryChange"
        @select="onSelect"
        v-model="select11"
      ></ui-select>
    </div>
<!-- <LayerVue
      :visible.sync="cropperDialogVisible"
      :shadeClose="true"
      :title="false"
      :shade="true"
      :area="['1024px', '750px']"
    >
    <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <cropper
            :imgurl="tailorimg"
            @upload_success="onMobileCoverImageUploadSuccess"
          />
        </div>
      </div>
    </LayerVue> -->
    <!-- vueCropper 剪裁图片实现-->
    <!-- <el-dialog title="图片剪裁" :visible.sync="cropperDialogVisible" append-to-body>
      
    </el-dialog> -->

    <div style="border: 1px solid #000;">      
      <div id="product_warpper" style="align-items: center;">
        <div class="product_pic" v-if="currentProduct != null" style="border:1px solid #ccc;" @click="onCropperImage">
          <img :src="currentProduct.imagePath" alt="Image" style="height:400px;" />
        </div>
        <div class="product_desc" v-if="currentProduct != null">
          <p class="title">
            {{ currentProduct.productName }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Appellation' : '产区' }}：</span
            >{{ currentProduct.region || '' }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Type' : '品种' }}：</span
            >{{ currentProduct.productType }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Varieties' : '葡萄品种' }}：</span
            >{{ currentProduct.grapes || '' }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Size' : '规格' }}：</span
            >750ml
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Alcohol Volume' : '酒精度' }}：</span
            >{{ currentProduct.alcohol || '' }}%vol
          </p>
          <p>
            <span class="label">{{
              currentLang === 'en' ? 'Bouteille' : '入瓶'
            }}</span
            >：{{ currentLang === 'en' ? 'Au Chateau' : '酒庄入瓶' }}
          </p>
          <p>
            <span class="label"
              >{{ currentLang === 'en' ? 'Price' : '价格' }}：</span
            >{{ currentProduct.currencyKind + currentProduct.price }}
          </p>
          <p style="display:flex;">
            <span class="label" style="display:block;"
              >{{ currentLang === 'en' ? 'Tasting' : '品鉴说明' }}：</span
            ><span style="flex:1;">{{ currentProduct.tastingNote || '' }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import debounce from 'lodash.debounce'
import imgcropper from '@/views/product/components/imgcropper.vue'
export default {  
  components: {
    imgcropper
  },
  data() {
    return {
      cropperDialogVisible: false,
      // 裁剪组件的基础配置option
      tailorimg: '',
      show: false,
      currentCanvas: null,
      select11: '',
      select11Options: [],
      select11Loading: false,
      select11NoResults: false,
      select11LoadingTimeout: null,
      currentProduct: null,
      currentLang:'zh'
    }
  },
  methods: {
    onQueryChange(query) {
      if (query.length === 0) {
        return
      }
      this.fetchRemoteResults(query)
    },
    fetchRemoteResults: debounce(function(query) {
      this.select11Loading = true
      this.queryProducts(query)
    }, 500),
    onSelect(item, selected) {
      this.getProduct(item)
    },
    getProduct(product) {
      const _this = this
      this.$http
        .get('/api/product/GetProductByPoster', {
          ProductGuid: product.productGUID,
          lang: this.currentLang
        })
        .then(res => {
          _this.currentProduct = res.data
          _this.currentProduct.tastingNote = _this.currentProduct.tastingNote.replace(
            /\([^\)]*\)/g,
            ''
          )
          if(_this.currentProduct.imagePath){
            _this.currentProduct.imagePath=_this.$G.domain+_this.currentProduct.imagePath
          }else{
            _this.currentProduct.imagePath='http://www.mega-wine.com/img/default279x900.86410399.png'
          }
        })
    },
    queryProducts(query) {
      let _this = this
      this.$http
        .get('/api/product/QueryProductByPoster', {
          keyword: query
        })
        .then(res => {
          _this.select11Loading = false
          _this.select11Options = res.data.products.map(item => {
            item.label = item.productName
            return item
          })
        })
    },
    saveProductImg(params) {
      let _this = this
      this.$http
        .post('/NewAPI/Product/SaveProductImg', params)
        .then(res => {
          _this.$dlg.toast('图片保存成功',{messageType:'success',position:'topCenter',closeTime:3})
        })
    },
    onCropperImage(){      
      let _this=this
      //this.tailorimg=this.detailHeaderImg
      //this.cropperDialogVisible = true
      let dlg_options = {
        maxButton: false,
        title: '',
        backdropClose: true,
        width:1000,
        height:600,
        callback:data=>{
          _this.currentProduct.imagePath=_this.$G.domain+data.Data.path
          const params={
            FileName:data.Data.filename,
            FilePath:data.Data.path,
            FileLength:data.Data.length,
            ProductGuid:_this.currentProduct.productGUID
            }
            _this.saveProductImg(params)
        }
      }
      if (document.body.clientWidth < 700) {
        dlg_options.width = document.body.clientWidth
      }
      this.$dlg.modal(imgcropper, dlg_options)
    },
    onMobileCoverImageUploadSuccess(res) {
      // this.fileinfo = file
      // // 上传成功后将图片地址赋值给裁剪框显示图片
      // this.$nextTick(() => {
      //   // console.log(this.$G.domain + response.Data.FilePath);
      //   this.tailorimg = this.$G.domain + response.Data.FilePath
      //   this.cropperDialogVisible = true
      // })
      
      debugger
      // const _this = this;
      // // 回调保存
      // let params = {
      //   ProjectGuid: this.projectGuid,
      //   FilePath: res.Data.FilePath,
      //   CoverImagePath: res.Data.FilePath,
      //   MobileCoverImagePath: res.Data.FilePath
      // };
      // this.onSaveCoverImageUrl(params, function (path) {
      //   // _this.$refs.mobilecover.src = _this.$G.domain + path;
      //    _this.ProjectObj.MobileCoverImagePath = path
      //    _this.cropperDialogVisible = false
      // });
    }
  }
}
</script>

<style lang="scss" scoped>
.page_warpper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .toolbar {
    display: flex;
    justify-content: flex-start;
  }
}
#product_warpper {
  //border: 1px solid #000;
  display: flex;
  justify-content: flex-start;
  width: 1004px;
  height: 600px;
  padding: 20px 40px;
  position:relative;
  //background: url('~@/assets/images/poster_bg.jpg') repeat 0 0;
  .logo{
    position: absolute;
    left:10px;
    top:10px;
    text-align:center;
    line-height: 0;
    color:#ab8a62;
    font-size: 14px;
  }
  .product_pic {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 400px;
    height: 400px;
  }
  .product_desc {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    width: 600px;
    padding-right: 50px;
    font-size: 14px;
    .title {
      color: #8B0000;
      font-size: 30px;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      border-bottom: 1px solid #ab8a62;
      padding-bottom: 15px;
      font-weight: bold;
    }
    .label {
      color: #8B0000;
      font-family: sans-serif;
      font-weight: bold;
    }
    p {
      padding: 0;
      margin: 10px;
    }
  }
}
#poster_warpper {
  overflow: hidden;
}
</style>
